module.exports = __webpack_public_path__ + "27281ff707.woff2";